import React from 'react';
import { ArrowRightIcon, CheckIcon } from 'lucide-react';
import { featuredService, services } from '../data/services';
import { images } from '../data/shop';
export function ServicesSection() {
  return <section id="services" aria-labelledby="services-heading" className="bg-paper py-20 lg:py-28" data-id="element-244" data-mp="2gb4udr1a0707">
      <div className="mx-auto max-w-7xl px-6 lg:px-8" data-id="element-245" data-mp="2l8n078jzy63z">
        <div className="max-w-2xl" data-id="element-246" data-mp="2lb9ahfy9uzpw">
          <p className="mb-3 text-sm font-semibold text-accent" data-id="element-247" data-mp="26ka2o759gf7d">Services</p>
          <h2 id="services-heading" className="font-display text-3xl font-bold tracking-tight sm:text-4xl" data-id="element-248" data-mp="2bb097npfao3n">
            Everything from door dings to full refinishes.
          </h2>
          <p className="mt-4 text-lg leading-relaxed text-muted" data-id="element-249" data-mp="1xi0w1sd455z9">
            One shop for the whole repair. No farming work out, no surprises on the final bill.
          </p>
        </div>

        <div className="mt-14 grid gap-12 lg:grid-cols-12 lg:gap-16" data-id="element-250" data-mp="1nnr1c40p7vld">
          <article className="lg:col-span-5" data-id="element-251" data-mp="1sjfvtsxv2mat">
            <img src={images.collision} alt="Pickup truck on a frame straightening machine while a technician measures panel gaps" className="aspect-[4/3] w-full rounded-lg object-cover" data-id="element-252" data-mp="2pnaxr3uoqfkg" />
            <h3 className="mt-7 font-display text-2xl font-bold tracking-tight" data-id="element-253" data-mp="2ymxz5pnezldi">{featuredService.title}</h3>
            <p className="mt-3 leading-relaxed text-muted" data-id="element-254" data-mp="2unp6ko441tjj">{featuredService.description}</p>
            <ul className="mt-6 grid gap-3 sm:grid-cols-2" data-id="element-255" data-mp="26xl6uru1mdxt">
              {featuredService.inclusions.map(item => <li key={item} className="flex items-start gap-2.5 text-sm font-medium" data-id="element-256" data-mp="21zjok94fyine">
                  <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-accent" aria-hidden="true" data-id="element-257" data-mp="2fqoegji0bwkj" />
                  {item}
                </li>)}
            </ul>
            <a href="#estimate" className="group mt-8 inline-flex items-center gap-2 text-sm font-semibold text-accent hover:text-accent-strong" data-id="element-258" data-mp="1n7r81tswuyk3">
              Start a collision estimate
              <ArrowRightIcon className="h-4 w-4 transition-transform duration-150 group-hover:translate-x-0.5" aria-hidden="true" data-id="element-259" data-mp="3ibp8z8xdkulv" />
            </a>
          </article>

          <ul className="divide-y divide-line border-y border-line lg:col-span-7" data-id="element-260" data-mp="3s3vapadfiqe9">
            {services.map(service => <li key={service.title} className="py-7" data-id="element-261" data-mp="2zdcxhgizr8n4">
                <h3 className="font-display text-lg font-bold tracking-tight" data-id="element-262" data-mp="2zext79h1kxmk">{service.title}</h3>
                <p className="mt-1.5 max-w-2xl leading-relaxed text-muted" data-id="element-263" data-mp="34cg598qcvsys">{service.description}</p>
              </li>)}
          </ul>
        </div>
      </div>
    </section>;
}